import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleLocation() {
    let location = match_location.getAttribute("readonly") == null ? "Online" : ""
    match_location.value = location
    match_location.toggleAttribute("readonly")
  }
}
